export const EXERCISE_API_NAME_TO_ID = {
  ChestPress: 'chestPress',
  StandingCableRow: 'standingRow',
  OverheadPress: 'overheadPress',
  StiffLegDeadlift: 'stiffLeg',
  CableSquat: 'squat',
  LatPulldown: 'latPulldown',
  BicepCurl: 'bicepCurl',
  TricepPushDown: 'tricepPushdown',
};

export const EXERCISE_IDS = Object.values(EXERCISE_API_NAME_TO_ID);

export const EXERCISE_ID_TO_SOURCE_ID = {
  [EXERCISE_API_NAME_TO_ID.ChestPress]: 1,
  [EXERCISE_API_NAME_TO_ID.StandingCableRow]: 2,
  [EXERCISE_API_NAME_TO_ID.OverheadPress]: 3,
  [EXERCISE_API_NAME_TO_ID.StiffLegDeadlift]: 4,
  [EXERCISE_API_NAME_TO_ID.CableSquat]: 5,
  [EXERCISE_API_NAME_TO_ID.LatPulldown]: 6,
  [EXERCISE_API_NAME_TO_ID.BicepCurl]: 7,
  [EXERCISE_API_NAME_TO_ID.TricepPushDown]: 8,
};

export const BACKBONE_ACTIONS = {
  GET_USER_SESSION_EXERCISE_PERFORMANCE: 'getUserSessionExercisePerformanceData',
  GET_MEMBER_PERFORMANCE_PROFILE: 'getMemberPerformanceProfile',
  ADD_MEMBER_AWAY_PERIOD: 'addMemberAwayPeriod',
  DELETE_MEMBER_AWAY_PERIOD: 'deleteMemberAwayPeriod',
  SET_MEMBER_PERFORMANCE_TARGETS: 'setMemberPerformanceTargets',
  SET_MEMBER_PERFORMANCE_SHARING: 'setMemberPerformanceSharing',
  GET_SHARED_MEMBER_PERFORMANCE: 'getSharedMemberPerformance',
};
